/* HI BAGS USA — no API calls, no new images: rotates real Shopify collection links
   at the start of each UTC hour. All visitors see the same six choices each hour.
   Automatically updates while the page remains open. */
(() => {
  if (window.__hibagsHourlyCollectionsV1) return;
  window.__hibagsHourlyCollectionsV1 = true;
  let nextTimer;

  function update() {
    const hour = Math.floor(Date.now() / 3600000);
    document.querySelectorAll('.hb-impact-categories[data-hb-rotate="hourly"]').forEach((section) => {
      const tiles = Array.from(section.querySelectorAll('.hb-impact-categories__grid > .hb-impact-category'));
      if (!tiles.length) return;
      const visibleCount = Math.min(6, tiles.length);
      // The stride cycles through 12 distinct arrangements, refreshing most tiles each hour.
      const stride = tiles.length === 1 ? 0 : (tiles.length % 5 === 0 ? 3 : 5);
      const offset = (hour * stride) % tiles.length;
      const visible = new Set(Array.from({ length: visibleCount }, (_, index) => (offset + index) % tiles.length));
      tiles.forEach((tile, index) => {
        tile.classList.toggle('hb-hourly-active', visible.has(index));
      });
      section.classList.add('hb-hourly-ready');
      section.dataset.hbDisplayedHour = String(hour);
    });
    clearTimeout(nextTimer);
    // Schedule at the next exact UTC hour, allowing a small grace period for clock rounding.
    const delay = 3600000 - (Date.now() % 3600000) + 200;
    nextTimer = setTimeout(update, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
})();
